import {
  Box,
  Divider,
  FormControl,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { flexAllCentre, flexAllEnd } from "../../../styles/mui/styles/display";
import { AddUserModalBox, AddUserModalGrid } from "../style/style";
import fontWeight from "../../../styles/mui/fontWeight";
import {
  ButtonCloseStyle,
  ButtonVerifyStyle,
  FaXmarkIcon,
  HorizontalDivider,
} from "../../../app/styles/styles";
import { FieldSpacing } from "../../PriorAuthWorkFlow/styles/style";
import { FormInputText } from "../../../components/FormPriorAuthReAuth/FormInputText";
import { rules } from "../../../utils/validation/Validation";
import { FormInputDropdown } from "../../../components/FormPriorAuthReAuth/FormInputDropdown";
import FileUploadField from "./UploadDocument";
import { ButtonContained } from "../../../app/common/button";
import { ListOptions } from "../../../models/Master";
import { getValue } from "../../../utils";
import { MyAccountModel } from "../../../models/MyAccount";

export interface AddNotificationProps {
  modalFlag: boolean;
  setModalFlag: (flag: boolean) => void;
  postNotification: (payload: FormData) => void;
  notificationsState: any;
  notificationType: ListOptions[] | any;
  loggedInUserState: MyAccountModel;
}
const AddNotification: React.FC<AddNotificationProps> = ({
  modalFlag,
  setModalFlag,
  postNotification,
  notificationType,
  loggedInUserState,
}) => {
  const methods = useForm<any>({
    defaultValues: "",
  });
  const { control, handleSubmit } = methods;

  const [file, setFile] = useState<File>();

  const onSubmit = (data: any) => {
    const formData = new FormData();
    formData.append("NotificationTypeId", data.notificationType);
    formData.append("TitleOfNotification", data.notificationTitle);
    formData.append(
      "UploadedBy",
      getValue(loggedInUserState, "providerPortalUser.email") || "",
    );
    if (file) {
      formData.append("NotificationFile", file);
    }
    if (
      getValue(data, "notificationType") > 0 &&
      getValue(data, "notificationTitle")
    ) {
      postNotification(formData);
      setModalFlag(false);
    }
  };

  const onSubmitModal = () => {
    handleSubmit(onSubmit)();
  };

  const onCancel = () => {
    setModalFlag(false);
  };

  return (
    <Modal
      open={modalFlag}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={flexAllCentre}
    >
      <Box sx={AddUserModalBox(true)}>
        <Grid container mb="0.4rem">
          <Grid size={{ xs: 11.5 }}>
            <Typography
              id="modal-modal-title"
              fontWeight={fontWeight[6]}
              variant="h1"
            >
              Add Notification
            </Typography>
          </Grid>
          <Grid size={{ xs: 0.5 }}>
            <IconButton onClick={() => onCancel()}>
              <FaXmarkIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Divider sx={HorizontalDivider} />
        <Grid
          container
          spacing={2}
          sx={{
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid size={{ xs: 6 }} sx={FieldSpacing}>
            <FormInputText
              control={control}
              helper={rules.notificationTitle}
              name={"notificationTitle"}
              label="Title of Notification: "
              textLength={100}
              disabled={false}
            />
          </Grid>
          <Grid size={{ xs: 6 }} sx={FieldSpacing}>
            <FormControl variant="standard" fullWidth>
              <FormInputDropdown
                label={"Notification Type:"}
                control={control}
                name={"notificationType"}
                list={notificationType}
                helper={rules.notificationTypeRequired}
                arrowDropDownIcon={false}
              />
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12 }} sx={FieldSpacing}>
            <FileUploadField
              setFile={setFile}
              control={control}
              file={file}
              name={"notificationFile"}
            />
          </Grid>
        </Grid>
        <Divider sx={HorizontalDivider} />
        <Grid container sx={AddUserModalGrid}>
          <Grid size={{ xs: 12 }} sx={flexAllEnd}>
            <ButtonContained
              id="btnSubmitNotification"
              onClick={() => onSubmitModal()}
              label="Submit"
              disabled={false}
              style={ButtonVerifyStyle}
            />
            <ButtonContained
              id="btnCancelNotification"
              onClick={() => onCancel()}
              label="Cancel"
              disabled={false}
              style={ButtonCloseStyle}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
export default AddNotification;
